import { useCallback, useState } from 'react';

import {
  MetadataConnectionModalScreens,
  useSFConnectionState,
} from '@contexts/sf-connection-context';

import { SalesforceConnectionsService } from '@modules/salesforce/services';

const usePrepareMetadataSync = () => {
  const { selectedConnection, handleUpdateMetadataConnectionModalScreen } =
    useSFConnectionState();

  const [isConnecting, setIsConnecting] = useState<boolean>(false);

  const handleGoBack = useCallback(() => {
    handleUpdateMetadataConnectionModalScreen(
      MetadataConnectionModalScreens.CONNECTION_CREATE_SCREEN,
    );
  }, [handleUpdateMetadataConnectionModalScreen]);

  const startSync = useCallback(() => {
    setIsConnecting(true);
    SalesforceConnectionsService.syncMetadata(selectedConnection?.id)
      .then(() => {
        handleUpdateMetadataConnectionModalScreen(
          MetadataConnectionModalScreens.METADATA_SYNC_POLLING_SCREEN,
        );
      })
      .catch(() => {
        handleUpdateMetadataConnectionModalScreen(
          MetadataConnectionModalScreens.METADATA_SYNC_FAILURE_SCREEN,
        );
      })
      .finally(() => {
        setIsConnecting(false);
      });
  }, [selectedConnection, handleUpdateMetadataConnectionModalScreen]);

  return {
    isConnecting,
    handleGoBack,
    startSync,
    environment: selectedConnection?.environmentName ?? '',
  };
};

export { usePrepareMetadataSync };
